import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import OrderModal from '../components/OrderModal';

const blackOpsProducts = [
  { name: "1 HOUR", price: "$25.00", url: "https://buy.stripe.com/14AcN535ndPjazy61tbV608" },
  { name: "2 HOURS", price: "$45.00", url: "https://buy.stripe.com/dRmfZhgWdh1vfTS2PhbV609" },
  { name: "3 HOURS", price: "$65.00", url: "https://buy.stripe.com/14A6oH8pH26B232dtVbV60a" },
  { name: "4 HOURS", price: "$85.00", url: "https://buy.stripe.com/5kQ3cveO5cLf0YY4XpbV60b" },
  { name: "5 HOURS", price: "$100.00", url: "https://buy.stripe.com/9B6cN57lD8uZ3764XpbV612" },
  { name: "6 HOURS", price: "$115.00", url: "https://buy.stripe.com/00w7sLfS97qVdLKgG7bV60Q" },
  { name: "7 HOURS", price: "$130.00", url: "https://buy.stripe.com/eVq6oH9tLcLf5feexZbV60R" },
  { name: "8 HOURS", price: "$145.00", url: "https://buy.stripe.com/eVq7sL49rdPjcHGcpRbV60S" }
];

const masteryCamos = [
  { name: "SINGULARITY", price: "$150.00", url: "https://buy.stripe.com/bJe4gz9tLh1vazy4XpbV618" },
  { name: "APOCALYPSE", price: "$220.00", url: "https://buy.stripe.com/bJe5kD21jdPjcHG1LdbV61a" },
  { name: "GENESIS", price: "$200.00", url: "https://buy.stripe.com/14A00j9tL12xazy3TlbV619" },
  { name: "INFESTATION", price: "$240.00", url: "https://buy.stripe.com/4gM8wP7lD9z37nm0H9bV61b" }
];

const BlackOpsPage = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll to hash section on load
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }, [location.hash]);

  const handleOrderClick = (item) => {
    const token = localStorage.getItem('token');
    if (!token) {
      // Save intended product in session storage
      sessionStorage.setItem('intendedOrder', JSON.stringify({ product: item, page: 'blackops' }));
      navigate('/login');
      return;
    }
    setSelectedProduct(item);
    setIsModalOpen(true);
  };

  // Check if returning from login with intended order
  useEffect(() => {
    const intendedOrder = sessionStorage.getItem('intendedOrder');
    if (intendedOrder) {
      const { product, page } = JSON.parse(intendedOrder);
      if (page === 'blackops') {
        sessionStorage.removeItem('intendedOrder');
        setSelectedProduct(product);
        setIsModalOpen(true);
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0f172a] text-[#f8fafc]">
      <Navbar />
      
      {/* Hero */}
      <section className="relative py-48 md:py-56 overflow-hidden min-h-[500px]">
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-[#0f172a] z-10"></div>
          <video 
            src="/images/bo7-page.webm"
            autoPlay loop muted playsInline
            className="w-full h-full object-cover object-top opacity-40"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center pt-16">
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter uppercase mb-6" data-testid="blackops-hero-title">
            <span className="text-orange-500">BLACK OPS 7</span> SERVICES
          </h1>
          <p className="text-xl text-slate-400 font-['Rajdhani'] tracking-wide">
            AFK Bot Lobbies sold by the hour - Max your camos fast
          </p>
        </div>
      </section>

      {/* Products */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-20">
          {/* Bot Lobbies */}
          <div id="bot-lobbies">
            <h2 className="text-3xl md:text-5xl mb-2 text-orange-500 tracking-wider font-['Bangers'] drop-shadow-[3px_3px_0px_rgba(0,0,0,0.8)]" data-testid="bot-lobbies-title">
              BLACK OPS 7 BOT LOBBIES
            </h2>
            <p className="text-lg md:text-xl text-yellow-400 mb-8 tracking-wider font-['Bangers'] drop-shadow-[2px_2px_0px_rgba(0,0,0,0.8)]">(Per Hour)</p>
            <div className="bg-[rgba(30,41,59,0.7)] border border-cyan-500 backdrop-blur-xl p-6 md:p-8 rounded-3xl mb-10" data-testid="bo7-lobbies-description">
              <p className="text-slate-300 leading-relaxed mb-4">
                Our BO7 bot lobbies are sold by the hour to give you more for your money. We put you one long Domination game so you aren't spending your time in the lobby loading into new games. You can easily unlock all the best rewards and achievements including all the best Gun Skins and calling cards! You can unlock Singularity and other mastery camos in a fraction of the time!
              </p>
              <p className="text-slate-300 leading-relaxed">
                Rest assured our BO7 Bot Lobbies are 100% safe! So you dont have to worry about shadow bans like you do with our competitors!
              </p>
            </div>
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {blackOpsProducts.map((item, index) => (
                <div 
                  key={index}
                  className="bg-[rgba(30,41,59,0.7)] border-2 border-orange-500/60 backdrop-blur-xl p-8 rounded-2xl hover:border-orange-400 hover:-translate-y-1 transition-all duration-200 relative"
                  data-testid={`product-${index}`}
                >
                  <img 
                    src="/images/titan-logo.png"
                    alt="Black Ops 7 Badge"
                    className="w-16 h-16 md:w-20 md:h-20 absolute top-2 right-2"
                  />
                  <h3 className="text-2xl font-bold uppercase mb-4 text-white font-['Poppins',sans-serif]">
                    {item.name}
                  </h3>
                  <p className="text-4xl font-black text-orange-500 mb-6">{item.price}</p>
                  <button 
                    onClick={() => handleOrderClick(item)}
                    data-testid={`order-button-${index}`}
                    className="w-full relative overflow-hidden bg-gradient-to-r from-orange-700 via-orange-600 to-amber-500 text-white font-bold py-3 px-6 uppercase tracking-widest transition-all duration-300 rounded-lg text-sm shadow-lg shadow-orange-900/50 hover:shadow-orange-500/60 hover:scale-[1.02] border border-orange-400/30"
                  >
                    <span className="relative z-10">ORDER NOW</span>
                  </button>
                </div>
              ))}
                </div>
              </div>
              <div className="hidden lg:flex items-center justify-center flex-shrink-0">
                <img 
                  src="/images/bo7-character.png"
                  alt="Black Ops 7 Character"
                  className="w-56 xl:w-64 rounded-3xl border border-orange-500 object-cover"
                  style={{ imageRendering: 'high-quality' }}
                  data-testid="bo7-character-image"
                />
              </div>
            </div>
          </div>

          {/* Mastery Camos */}
          <div id="mastery-camos" className="border-t border-white/10 pt-12">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <h2 className="text-3xl md:text-5xl mb-2 text-orange-500 tracking-wider font-['Bangers'] drop-shadow-[3px_3px_0px_rgba(0,0,0,0.8)]" data-testid="mastery-camos-title">
                  MASTERY CAMOS
                </h2>
                <p className="text-lg md:text-xl text-yellow-400 mb-8 tracking-wider font-['Bangers'] drop-shadow-[2px_2px_0px_rgba(0,0,0,0.8)]">Piloted Boosts: We play for you</p>
                <div className="bg-[rgba(30,41,59,0.7)] border border-cyan-500 backdrop-blur-xl p-6 md:p-8 rounded-3xl mb-10" data-testid="mastery-camos-description">
                  <p className="text-slate-300 leading-relaxed mb-4">
                    Mastery Camos are the hardest gun camos to unlock in the entire game! When other players see you with any of these camos they are immediately impressed!
                  </p>
                  <p className="text-slate-300 leading-relaxed">
                    Mastery Camo boosts are completed by one of our Professional boosters. We play for you and get the job done quick! So you can kick back and relax and in no time you'll have the Mastery camo you ordered.
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                  {masteryCamos.map((item, index) => (
                    <div 
                      key={index}
                      className="bg-[rgba(30,41,59,0.7)] border-2 border-orange-500/60 backdrop-blur-xl p-6 rounded-2xl hover:border-orange-400 hover:-translate-y-1 transition-all duration-200"
                      data-testid={`mastery-${index}`}
                    >
                      <h3 className="text-xl font-bold uppercase mb-4 text-white font-['Poppins',sans-serif]">{item.name}</h3>
                      <p className="text-3xl font-black text-orange-500 mb-6">{item.price}</p>
                      <button 
                        onClick={() => handleOrderClick(item)}
                        data-testid={`mastery-button-${index}`}
                        className="w-full relative overflow-hidden bg-gradient-to-r from-orange-700 via-orange-600 to-amber-500 text-white font-bold py-3 px-6 uppercase tracking-widest transition-all duration-300 rounded-lg text-sm shadow-lg shadow-orange-900/50 hover:shadow-orange-500/60 hover:scale-[1.02] border border-orange-400/30"
                      >
                        <span className="relative z-10">ORDER NOW</span>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              <div className="hidden lg:flex items-center justify-center flex-shrink-0">
                <img 
                  src="/images/bo7-character-2.png"
                  alt="Black Ops 7 Mastery Camos"
                  className="w-64 xl:w-72 rounded-3xl border border-orange-500 object-cover"
                  data-testid="bo7-mastery-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <OrderModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        product={selectedProduct}
      />

      <Footer />
    </div>
  );
};

export default BlackOpsPage;